import { Picture, TextVerticalSpacer, theme } from '@superhi/design'
import styled from 'styled-components'

export const Wrapper = styled.div`
  position: relative;
  border-radius: 10px;
  overflow: hidden;
`

export const BackgroundImage = styled(Picture)`
  background-color: ${theme.colors.YELLOW_50};
  position: absolute;
  top: 0;
  z-index: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

export const Content = styled(TextVerticalSpacer).attrs({ level: '1' })`
  position: relative;
  padding: 24px;
  z-index: 1;

  @media ${theme.breakpoints.large} {
    padding: 32px;
  }
`

export const Buttons = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: -8px;

  > * {
    margin: 8px;
  }
`
